export default function normalizeTableParams({
  app,
  packageName,
  selectedFilters,
}) {
  const { tag, range } = selectedFilters;
  const { type, child, tag: selectedTag } = tag;
  const params = {
    stat_type: type,
    child,
    tag: selectedTag,
    range,
    is_table: 1,
    packageName,
  };
  const { haveIap } = app;
  if (haveIap) {
    params.is_in_app = 1;
  }
  return params;
}
